import React from 'react';

import classes from './Header.css';
import Navbar from '../Navbar/Navbar';

const Header = ({ timestamp=0 }) => {
	return (
         <header role="banner">
             <h1>COVID - 19</h1>
             <Navbar/>
         </header>
	)
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header/Header.js